import { useContext } from "react";
import { AppContext } from "../App";
import { RiHome6Line, RiNotification3Line, RiShoppingBag3Line } from "react-icons/ri";
import { FaRegUser } from "react-icons/fa";
import { STR_ACCOUNT, STR_MENU_HOME } from "../Strings";

export default function BottomBar() {
  const appContext = useContext(AppContext);

  return (
    <div className="BottomBar">
      <div className="barInner">

        <div
          className="mIcon"
          data-active={appContext.navItem === 'home' || !appContext.navItem}
          onClick={() => appContext.navTo({ item: 'home' })}
        >
          <RiHome6Line className="mSymbol" />
          <div className="mText">{STR_MENU_HOME[appContext.language]}</div>
        </div>

        <div
          className="mIcon"
          data-active={appContext.navItem === 'my-orders'}
          onClick={() => appContext.navTo({ item: 'my-orders' })}
        >
          <RiShoppingBag3Line className="mSymbol" />
          <div className="mText">Orders</div>
        </div>

        <div
          className="mIcon"
          data-active={appContext.navItem === 'notifications'}
          onClick={() => appContext.navTo({ item: 'notifications' })}
        >
          <RiNotification3Line className="mSymbol" />
          <div className="mText">Updates</div>
        </div>

        <div
          className="mIcon"
          data-active={appContext.navItem === 'account'}
          onClick={() => appContext.navTo({ item: 'account' })}
        >
          <FaRegUser className="mSymbol" />
          <div className="mText">{STR_ACCOUNT[appContext.language]}</div>
        </div>

      </div>
    </div>
  );
}
